import { SoftphoneIntegrationEnum, TimeEnum } from '@lib/enums';

import type { AppConfig } from '@config';

export const ProdConfig = {
  apiKeyGoogleMaps: 'AIzaSyB6aRjr-BiiOP2tPG4OLlcLmDl73NfhzXw',
  appEnv: 'production',
  azure: {
    appInsightsConnectionString:
      'InstrumentationKey=5721846f-5a2d-4eed-8586-45c341aec384;IngestionEndpoint=https://centralus-2.in.applicationinsights.azure.com/;LiveEndpoint=https://centralus.livediagnostics.monitor.azure.com/',
    appInsightsKey: '5721846f-5a2d-4eed-8586-45c341aec384',
    authority: 'https://login.microsoftonline.com/daae7bc1-c893-46c4-8df4-4464a9a6f43e',
    clientId: '6d2a0960-e127-40a2-bd33-9fa6eb4aa328',
    tenantId: 'daae7bc1-c893-46c4-8df4-4464a9a6f43e',
  },
  gatewayUrl: 'https://end-gateway-kitt-prod.azurewebsites.net/api/v1',
  paymentUrl: 'https://enduipaymentkittprod-c0bmapc8bkdqfren.z01.azurefd.net/',
  pcrsPortalUrl: 'https://pcrsauto.com/PCMI.Web.Portal.Core',
  softphoneIntegration: {
    client: SoftphoneIntegrationEnum.Contacts,
    enabled: true,
    enableDebugLogs: false,
  },
  defaultApiTimeout: TimeEnum.ThirtySeconds,
  sentryIngestionEndpoint:
    'https://4c7389d417facfc54fc63ce40581895a@o4506672688791552.ingest.sentry.io/4506672696393728',
} satisfies AppConfig;
